import { forwardRef } from 'react';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const GenerationToolLabel = forwardRef(
  (
    {
      className,
      classes,
      label,
      description,
      boldLabel,
      grayDescription,
      boldDescription,
      hideSeparator,
      ...restProps
    },
    ref
  ) => {
    const styles = useStyles({ classes });

    return (
      <Typography
        className={cx(styles.root, className, {
          [styles.boldLabel]: boldLabel,
          [styles.grayDescription]: grayDescription,
          [styles.boldDescription]: boldDescription,
        })}
        ref={ref}
        {...restProps}
      >
        <span className={styles.label}>{label}</span>
        {description && (
          <>
            {hideSeparator ? ' ' : <span className={styles.separator}>-</span>}
            <span className={styles.description}>{description}</span>
          </>
        )}
      </Typography>
    );
  }
);

GenerationToolLabel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  boldLabel: PropTypes.bool,
  grayDescription: PropTypes.bool,
  boldDescription: PropTypes.bool,
  hideSeparator: PropTypes.bool,
};

GenerationToolLabel.defaultProps = {
  className: '',
  classes: null,
  description: '',
  boldLabel: false,
  grayDescription: false,
  boldDescription: false,
  hideSeparator: false,
};
